import axios from 'axios';

import { ClientError } from '$app-web/utils';

class AxiosClientsManager {
    constructor() {
        this.clients = {};
    }

    createClient(clientId, options) {
        this.clients[clientId] = axios.create(options);
        return this.clients[clientId];
    }

    getClient(clientId) {
        if (this.clients[clientId] != null) {
            return this.clients[clientId];
        }
        throw new ClientError(`Trying to get missing client. Please call createClient first. clientId: ${clientId}`);
    }
}

const instance = new AxiosClientsManager();
export default instance;
